const utils = require("frontend-controller/lib/utils");
module.exports = {
    config: {
        showColorBar: false,
        tabConfigNavKey: '',
        openTabsInMainNav: false,
        showEditByMySelf: false, // used for e.g., modal actions
        usage: null, // may be 'selection' if showEdit should be used as select. e.g., moving projectTerms to another project uses a target project selection
        isMultiSelect: true,
        parentEntityPreparationGranted: true,
    },

    model: {
        tabConfig: false,
        parentEntity: null,
        decisionOrigin: null,
    },

    methods: {
        prepare(){
            // prevent parentEntity from being stored within model if necessary. e.g., prevent data cascades in case of projects since they are at the very top in every use case.
            if(this.config.parentEntityPreparationGranted){
                this.model.parentEntity = this.getResourceRegisterContent('parentEntity') || {}
            }
            this.model.decisionOrigin = this.getResourceRegisterContent('decisionOrigin') || {}
            utils.refMerge(this.config, this.getResourceRegisterContent('controllerConfig') || {})
        },

        gatherTabConfig(){
            if(!this.model.tabConfig && this.config.tabConfigNavKey){
                this.furthest('base_tabStrip_tabStrip', undefined, mainNav => {
                    const tab = mainNav.getTabByNavKey(this.config.tabConfigNavKey)
                    if((tab || {}).resourceData){
                        const colors = tab.resourceData.colors || {}
                        this.model.tabConfig = {
                            activeBG: colors.activeSubTabBG,
                            colorBarColor: colors.activeBG || '#818181',
                            icon: tab.resourceData.aliasIcon,
                            iconColor: colors.activeBar,
                        }
                    }
                })
            }
        },

        initColorBar(){
            if(this.config.showColorBar && (this.model.tabConfig || {}).colorBarColor){
                const $container = this.$.find('section.left')
                const $colorBar = $container.find('.templates_core_controller_colorBar')
                if($container.length > 0 && $colorBar.length < 1){
                    $container.prepend(
                        this.include(
                            './colorBar',
                            {
                                model: {
                                    color: this.model.tabConfig.colorBarColor
                                }
                            }
                        )
                    );
                }
            }
        },

        showInsert(buttonContext, buttonMode, extensionData, resourceRegister){
            const baseActionKey = `showInsert_${buttonContext}${buttonMode ? `_${buttonMode}` : ''}`
            const actionKey = `${baseActionKey}_inEffect`
            const parentEntity = this.model.parentEntity || {}
            extensionData = extensionData || {}
            resourceRegister = resourceRegister || {}

            // prevent resourceID usage via resourceRegisterKey in case of insertions.
            resourceRegister = utils.simpleMerge({
                parentEntityForProperties: {
                    resourceID: null
                }
            }, resourceRegister)

            // add parents primaryKey as foreign key if necessary
            if(parentEntity.primaryKey && parentEntity.entityID){
                resourceRegister = utils.simpleMerge(resourceRegister, {
                    dirtyAttributesForProperties: {
                        [parentEntity.primaryKey]: parentEntity.entityID,
                    }
                })
            }

            return this.performAndStoreAction(
                actionKey,
                this.prepareAction(baseActionKey, undefined, resourceRegister, extensionData),
                true
            )
        },

        showEdit(context, entityID, entityData, resourceRegister, extensionData){
            if(this.config.usage === 'ignore') {
                return
            }

            resourceRegister = resourceRegister || {}
            entityData = entityData || {}
            const entityAttributes = entityData.attributes || {}

            this.gatherTabConfig()

            resourceRegister.tabOptions = this.sanitizeTabOptionsByAttributes({
                icon: this.model.tabConfig.icon,
                colors: {
                    activeBG: this.model.tabConfig.activeBG,
                    icon: this.model.tabConfig.iconColor,
                },
                title: entityAttributes.title,
                titleSuffix: ` [${entityID}]`
            }, entityAttributes, entityID)
            resourceRegister.parentEntity = {
                entityID,
                entityData,
                primaryKey: entityData.primaryKey,
            }
            resourceRegister.parentEntityForProperties = {
                resourceID: entityID,
            }
            resourceRegister.parentEntityForTable = {
                baseFilters: {
                    [entityData.primaryKey]: entityID
                }
            }
            resourceRegister.parentEntityForStatus = {
                baseFilters: {
                    [entityData.primaryKey]: entityID,
                    hindersCustomerOrder: this.scope === 'customers',
                }
            }
            resourceRegister.decisionOrigin = this.model.decisionOrigin

            let showEditBossComponent, showEditMethod = 'showEdit'
            if(this.config.usage === 'selection') {
                showEditMethod = 'select'
                showEditBossComponent = this
            } else if(this.config.showEditByMySelf) {
                showEditMethod = 'performShowEdit'
                showEditBossComponent = this
            } else if(this.config.openTabsInMainNav){
                showEditBossComponent = getComponent('mainNav')
            } else {
                this.closest('templates_core_tabStrip_tabStrip', tabStrip => {
                    showEditBossComponent = tabStrip
                })
            }

            if(showEditBossComponent && utils.isFunction(showEditBossComponent[showEditMethod])){
                return showEditBossComponent[showEditMethod](context, entityID, resourceRegister, entityData, extensionData)
            } else {
                console.error('showEditBossComponent missing')
            }
        },

        performShowEdit(context, entityID, resourceRegister, entityData, extensionData){
            const baseActionKey = `showEdit_${context}`
            const actionKey = `${baseActionKey}_inEffect_${entityID}`

            if(this.actions[actionKey]){
                return this.performAction(actionKey)
            } else {
                return this.performAndStoreAction(
                    actionKey,
                    this.prepareAction(baseActionKey, entityID, resourceRegister, extensionData || {}),
                    false
                )
            }
        },

        select(context, entityID, resourceRegister, entityData){
            this.triggerClosest('onDecision', {
                decisionComponent: this,
                decisionType: 'submit',
                decisionOrigin: resourceRegister.decisionOrigin || {},
                decisionOptions: {
                    context,
                    entityID,
                    entityData,
                    resourceRegister,
                }
            });
        },

        delete(buttonContext, entityID, entityData){
            const baseActionKey = `delete_${buttonContext}`

            if(this.actions[baseActionKey] && !utils.isEmpty(entityID)){
                return this.performDecision(
                    'confirm',
                    {
                        component:  this,
                        title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
                        message:    storage.__('hint.delete.really.' + buttonContext + '.message')
                    }
                ).then(context => {
                    if (context.decision.type === 'yes') {
                        return this.performAction(
                            this.prepareAction(baseActionKey, entityID)
                        ).then(context => {
                            // this is an additional call to prevent local client errors if heartbeat fails.
                            this.callHandler('postDeleteRecord', [
                                buttonContext,
                                entityID,
                                entityData
                            ]);
                            return context;
                        });
                    }

                    return utils.promise.reject();
                });
            }
        },

        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            return tabOptions
        },

        async submit(options = {}){
            let form
            this.find('templates_core_form_propertiesForm', c => {
                form = c
                return 'break'
            })
            if(!form){
                this.find('base_form_form', c => {
                    form = c
                    return 'break'
                })
            }
            if(!form){
                console.error('MISSING FORM')
                return utils.promise.resolve()
            }

            return form.submit(options)
        },
    },

    hooks: {
        attach: function($element, options){
            this.gatherTabConfig()

            if(options.refresh) {
                this.model.colorBarInitialized = false
                this.initColorBar()
            }

        },

        onDecision($element, options){
            switch(options.decisionType){
                case 'submit':
                case 'submitRefresh':
                case 'submitAndRedo':
                case 'submitAndOrder':
                    switch(options.decisionComponent.componentClass) {
                        case 'base_modal_modal':
                        case 'templates_core_modal_modal':
                            const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
                            if(utils.isFunction((modalContentComponent || {}).submit)){
                                const submitOptions = {}
                                if(options.decisionType === 'submitAndRedo'){
                                    submitOptions.redo = true
                                } else if(options.decisionType === 'submitAndOrder'){
                                    submitOptions.order = true
                                }

                                modalContentComponent
                                    .submit(submitOptions)
                                    .then(() => {
                                        if(options.decisionType === 'submitRefresh') {
                                            modalContentComponent.refresh()
                                        } else {
                                            options.decisionComponent.hide()
                                        }
                                    })
                                ;
                            } else {
                                options.decisionMade = false
                            }
                            break;
                    }
                    break;

                case 'cancel':
                    switch(options.decisionComponent.componentClass) {
                        case 'base_modal_modal':
                        case 'templates_core_modal_modal':
                            options.decisionComponent.hide();
                            break;
                    }
                    break;

                default:
                    options.decisionMade = false
                    break;
            }
        }
    },

    handlers: [{
        name: 'onTabActivate',
        componentClass: 'templates_core_tabStrip_tab',
        handle: function(callerComponent){
            if(callerComponent.config.isMainTab){
                this.gatherTabConfig()
                this.initColorBar()
            }
        }
    }]
}
